import { createAsyncThunk } from "@reduxjs/toolkit";
import { getClientUsers, getTableColumnNames, getAIChatReport, getAIChat, updateChatFeedbackStatusApi, deleteAIChatReportApi } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Chat Report Table Column Names
export const fetchAIChatReportTableColumnNames = createAsyncThunk(
  "aiChatReport/fetchAIChatReportTableColumnNames",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getTableColumnNames(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);


// Fetch Chat Report
export const fetchAIChatReport = createAsyncThunk(
  "aiChatReport/fetchAIChatReport",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getAIChatReport(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching chat report");
    }
  }
);


export const fetchAIChat = createAsyncThunk(
  "aiChatReport/fetchAIChat",
  async (chatReport, { rejectWithValue }) => {
    try {
      const response = await getAIChat(chatReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching chats");
    }
  }
);

// Get Client Users
export const fetchAIClientUsers = createAsyncThunk(
  "aiChatReport/fetchAIClientUsers",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getClientUsers(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching client users");
    }
  }
);

// updateChatFeedbackStatus
export const updateChatFeedbackStatus = createAsyncThunk(
  "aiChatReport/updateChatFeedbackStatus",
  async (feedbackData, thunkAPI) => {
    try {
      const response = await updateChatFeedbackStatusApi(feedbackData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error updating chat feedback status");
    }
  }
);

// Delete Chat Report
export const deleteAIChatReport = createAsyncThunk(
  "aiChatReport/deleteAIChat",
  async (chatReport, { rejectWithValue }) => {
    try {
      const response = await deleteAIChatReportApi(chatReport);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting chat report");
    }
  }
);